import { getCountryNameByCountryCode } from "../../../../../utils/utility";

export function getInitialMarginData({
    countryList = [],
    columns = [],
    defaultMarginData = [],
    selectedMargins = []
}) {
    if (!defaultMarginData.length) return null;

    let result = [];
    defaultMarginData.forEach(defaultMargins => {
        const country = defaultMargins.countryCode;
        let marginData = {
            id: country
        };

        const existingCountryMargins = selectedMargins ? selectedMargins.filter(countryMargin => countryMargin.id === country) : [];

        columns.forEach(margin => {
            const marginType = margin.id;
            if (marginType !== "country") {
                const defaultMarginValue = defaultMargins[marginType];
                const existingMarginValue = existingCountryMargins.length ? existingCountryMargins[0][marginType] : 0;
                marginData[marginType] = existingMarginValue || defaultMarginValue || 0;
            }
        });

        result.push(marginData);
    });

    return result;
}

export default function paymentMarginOnePointOne(config){
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach(countryMargins => {
        const countryCode = countryMargins.id;
        let row = [];
        const rowId = `${config.tableType}|${countryCode}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            
            let columnValue = countryMargins[columnId] || 0;
            let columnValueData = null;

            if (columnDataType === "string") {
                if (columnId === "country") {
                    columnValue = getCountryNameByCountryCode(countryCode);
                }
            }
            else {
                columnValueData = { ...column.data };
                columnValueData.defaultValue = columnValue;
            }


            row.push({
                [columnId] : {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, countryCode) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}